<template>
  <div class="card-body maxheight">
    <div class="row justify-content-center">
      <div class="col-8">
        <div class="row lead">
          <span v-if="usesQ4">{{ buildTitle(data.title, user) }}</span><span v-else>
            {{ data.title }} 
          </span><br><span class="bolder ml-2"><small> Select all that apply. </small></span>
        </div>
        <div class="row ml-3 my-3">
          <form>
            <div v-for="(response, index) in data.responses" v-bind:key="index" class="form-check mt-1">
              <input v-model="answer" @change="onChangeValue(response,index)" class="form-check-input" type="checkbox" :value="index" />
              <label class="form-check-label" for="exampleRadios1" @click="onClick(response,index)">
                <div v-if="response=='My organization has implemented all of the above MSD reduction initiatives'||response=='My organization has not implemented any MSD reduction initiatives'"
                ><i>{{ response }}</i></div>
                <div v-else>{{ response }}</div>
                <input v-if="uniqueQuestion == index" v-show="answer.includes(uniqueQuestion)" type="uniqueInput" @input="onTextChange()"
                  v-model="uniqueInput" class="form-control" />
                  <p  v-show="textError===true && answer.includes(uniqueQuestion)" v-if="uniqueQuestion == index" class="text-danger small">Please enter a response</p>
              </label>
            </div>
          </form>
          
        </div>
          
          <p v-if="inputError===true" class="text-danger small">Please select at least one option </p>
      </div>
      
    </div>
  </div>
  <div class="card-footer border border-rounded">
    <div class="row justify-content-center">
      <div @click="previous()" class="btn btn-small  nsc-cta  mx-4 my-2">
      Previous
      </div>
  <div @click="validateAnswer" class="btn btn-small nsc-cta blue mx-4 my-2">
      Next
    </div>
  </div>
  </div>
</template>
<script>
export default {
  name: "CheckAll",
  props: ["data", "nextQ", "user", "prevQ","answers", "uniqueI"],
  emits: ["nextQuestion","previousQuestion","uniqueAnswer"],
  data() {
    return {
      usesQ4: this.data.usesQ4 ? true : false,
      uniqueQuestion: this.findUniqueInput(this.data.responses),
      answer: [],
      inputError: null,
      textError:null,
      uniqueInput: this.uniqueI,
      next: this.nextQ,
    };
  },
  methods: {
    buildTitle(arr, user) {
      return `${arr[0]} ${user.company} ${user.subsector} ${arr[1]}`;
    },
    validateAnswer() {
      if (
        this.answer.length < 1){
          this.inputError = true
        }
        else if (this.answer.includes(this.uniqueQuestion) &&
          !this.uniqueInput) {
        this.textError = true
      } else {
        this.next = this.questionPiping(this.data, this.answer)
        if (this.answer.includes(this.uniqueQuestion)) {
        this.$emit('uniqueAnswer', this.data.ID, this.uniqueInput);
      }
        this.$emit("nextQuestion", this.next, this.answer);
      }
    },
    findUniqueInput(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].includes("describe below")) {
          return i;
        }
      }
      return -1;
    },
    questionPiping(currentQ, answer) {
      if (currentQ.ID == 14) {
        if (answer.includes(11)) {
          return 15
        } else {
          return 16
        }
      }
      return this.next
    },
    previous(){
      this.$emit('previousQuestion', this.prevQ, this.answer)
    },
    onClick(res,idx){
      if(!this.answer.includes(idx)){ 
        this.answer.push(idx);
        this.onChangeValue(res,idx)
        }
    },
    onChangeValue(value, idx){
      this.inputError = false
      // let length = this.answer.length
      // console.log(this.answer.map(x => this.data.responses[x].split(' ').includes('all')).includes(true))
      if(this.answer.length == 1 ) return ;
      
      if(value.split(' ').includes('all') && this.answer.includes(idx)) return this.answer = [idx];
      if(value.split(' ').includes('not') && this.answer.includes(idx)) return this.answer = [idx];
      if(this.answer.map(x => this.data.responses[x].split(' ').includes('all')).includes(true)) return this.answer = [idx];
      if(this.answer.map(x => this.data.responses[x].split(' ').includes('not')).includes(true)) return this.answer = [idx];
      
      // if((this.data.responses[this.answer[length-1]].split(' ').includes('all') || this.data.responses[this.answer[length-1]].split(' ').includes('not')) && this.answer.length > 1 ) return console.log("HERE!!!!!");
      // console.log(this.answer)
      // this.answer.includes(this.data.responses[this.data.responses.length -1]) ? this.answer = [this.data.responses[this.data.responses.length -1]] : "";
    },
    onTextChange(){
      if(this.uniqueInput.length > 0){
        this.textError = false
      } else {
        this.textError = true
      }
    }
  },
  mounted() {
    for( let key in this.answers) this.answer.push(this.answers[key]); 
  }
};
</script>